// src/features/stock/pages/StockPage.jsx
import { Stack } from "@mui/material";

import StockMainSection from "../components/StockMainSection";

export default function StockPage() {
  return (
    <Stack
      spacing={2}
      sx={{
        pt: 2,
        pr: 3,
        pl: 0,
        width: "100%",
        minWidth: 0,
        overflowX: "hidden",
      }}
    >
      <StockMainSection />
    </Stack>
  );
}
